import React, { useEffect } from "react";
import { HashRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import "./styles/evolvance.css";
import Header from "./components/Header";
import Hero from "./components/Hero";
import FeaturedProducts from "./components/FeaturedProducts";
import Services from "./components/Services";
import BrandValues from "./components/BrandValues";
import CaseStudies from "./components/CaseStudies";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import SEODenseKeywords from "./components/SEODenseKeywords";
import DemoPage from "./pages/DemoPage";
import Privacy from "./pages/Privacy";
import Legal from "./pages/Legal";
import Cookies from "./pages/Cookies";
import Blog from "./pages/Blog";
import BlogAdmin from "./pages/BlogAdmin";
import CasosDeExito from "./pages/CasosDeExito";
import CookieConsent from "./components/CookieConsent";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const LandingPage = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      setTimeout(() => {
        const targetId = hash.includes('/#') ? hash.split('/#')[1] : hash.replace('#', '');
        const element = document.getElementById(targetId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  }, [pathname, hash]);

  return (
    <div className="App">
      <SEODenseKeywords />
      <Header />
      <main>
        <Hero />
        <FeaturedProducts />
        <Services />
        <BrandValues />
        <CaseStudies />
        <Contact />
      </main>
      <Footer />

      {/* WhatsApp Floating Button */}
      <a
        href="https://chat.whatsapp.com/GGqFSVOseGvDCzrjwP2OBZ?mode=gi_t"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-5 right-5 z-50 hover:scale-110 transition-transform duration-300"
        aria-label="WhatsApp"
      >
        <img
          src="https://iili.io/fczZ0vt.png"
          alt="WhatsApp"
          className="w-16 h-16 drop-shadow-2xl"
        />
      </a>
    </div>
  );
};

function App() {
  return (
    <Router>
      <ScrollToTop />
      <CookieConsent />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/demo" element={<DemoPage />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog-admin" element={<BlogAdmin />} />
        <Route path="/casos-de-exito" element={<CasosDeExito />} />
        <Route path="/privacidad" element={<Privacy />} />
        <Route path="/cookies" element={<Cookies />} />
        <Route path="/aviso-legal" element={<Legal />} />
      </Routes>
    </Router>
  );
}

export default App;
